import { ReactNode } from "react";

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  centered?: boolean;
  children?: ReactNode;
}

export const SectionHeader = ({
  eyebrow,
  title,
  subtitle,
  centered = true,
  children,
}: SectionHeaderProps) => {
  return (
    <div className={`mb-16 ${centered ? "text-center" : ""}`}>
      {eyebrow && (
        <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-4">
          {eyebrow}
        </p>
      )}
      <h2 className="heading-2 mb-6">{title}</h2>
      {subtitle && (
        <p
          className={`body-large text-muted-foreground ${
            centered ? "max-w-3xl mx-auto" : ""
          }`}
        >
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};
